import styled from 'styled-components';

const SmartmatchSubmissionFormStyles = styled.section`
  .smartmatch-iframe {
    width: 100%;
    max-width: 40rem;
  }
`;

export default SmartmatchSubmissionFormStyles;
